import axios from "axios";
import models from "../../models/grupos/models";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getModels(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/grpmodelos/${data}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return models.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      liqModeloId: items.id,
      grupoId: items.groupId,
      fecDesde: items.from + "T00:00:00.000Z",
      fecHasta:
        items.to == undefined
          ? undefined
          : moment.utc(items.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
    };
    return axios.post(`${url}/grpmodelos`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let date = moment(data.oldFrom, "DD-MM-YYYY").format("YYYY-MM-DD");

    const payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      fecHasta:
        data.to == undefined
          ? undefined
          : moment.utc(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
    };

    return axios.patch(
      `${url}/grpmodelos/${data.groupId}&${data.id}&${date}`,
      payload,
      {
        headers,
      }
    );
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const dateFrom = moment(data.from, "DD-MM-YYYY");
    let date = dateFrom.format("YYYY-MM-DD");
    return axios.delete(
      `${url}/grpmodelos/${data.groupId}&${data.id}&${date}`,
      { headers }
    );
  }
}
export default service;
